import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div style={{
      fontFamily: "'Roboto', sans-serif",
      maxWidth: '1100px',
      margin: '40px auto',
      padding: '20px 40px',
      lineHeight: 1.7,
      color: '#333',
      backgroundColor: '#fff',
      minHeight: '100vh',
      textAlign: 'left'
    }}>
      <h1 style={{
        textAlign: 'left',
        fontWeight: 500,
        fontSize: '1.8em',
        marginBottom: '30px'
      }}>Privacy Policy</h1>

      <p style={{ marginBottom: '1.2em' }}>
        This Privacy Policy explains how we collect, use, and protect your information when you use our 3D climbing guide application ("CruxLabs"). By using the CruxLabs App or submitting information to us, you agree to the practices described below.
      </p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>1. Information We Collect</h2>
      <p style={{ marginBottom: '1.2em' }}>We collect the following types of information:</p>
      <ul style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}><strong>Email Address:</strong> If you submit your email via our landing page, we will use it to notify you of updates and product launches.</li>
        <li style={{ marginBottom: '0.5em' }}><strong>User Contributions:</strong> If the app allows adding beta notes, comments, or route markings, we may store this content along with anonymized user metadata.</li>
        <li style={{ marginBottom: '0.5em' }}><strong>Data:</strong> We may collect device type, app version, and general usage statistics (e.g., number of times the app was opened).</li>
        <li style={{ marginBottom: '0.5em' }}><strong>Images:</strong> For image-based features (e.g., capturing or annotating climbing routes), any uploaded or generated media stays local unless you explicitly share or publish it.</li>
      </ul>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>2. How We Use Your Information</h2>
      <p style={{ marginBottom: '1.2em' }}>We use collected data to:</p>
      <ul style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}>Send launch updates or relevant notifications</li>
        <li style={{ marginBottom: '0.5em' }}>Improve the app and personalize features</li>
        <li style={{ marginBottom: '0.5em' }}>Enable user-generated content and collaboration tools</li>
      </ul>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>3. Data Sharing</h2>
      <p style={{ marginBottom: '1.2em' }}>We do <strong>not</strong> sell, rent, or share your personal data with third parties unless:</p>
      <ul style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}>We have your explicit consent</li>
        <li style={{ marginBottom: '0.5em' }}>We are required by law</li>
        <li style={{ marginBottom: '0.5em' }}>It is necessary to provide core services (e.g., secure data hosting)</li>
      </ul>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>4. Cookies & Analytics</h2>
      <p style={{ marginBottom: '1.2em' }}>Our landing website may use basic cookies for analytics and functionality (e.g., remembering if you've submitted your email). We do not use invasive tracking.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>5. Data Security</h2>
      <p style={{ marginBottom: '1.2em' }}>We implement reasonable safeguards to protect your information. However, no system is 100% secure, so we cannot guarantee absolute security.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>6. User Rights</h2>
      <p style={{ marginBottom: '1.2em' }}>You may contact us at any time to:</p>
      <ul style={{ marginBottom: '1.2em', paddingLeft: '20px' }}>
        <li style={{ marginBottom: '0.5em' }}>Access or update your stored information</li>
        <li style={{ marginBottom: '0.5em' }}>Request deletion of your data</li>
        <li style={{ marginBottom: '0.5em' }}>Opt out of communications</li>
      </ul>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>7. Children's Privacy</h2>
      <p style={{ marginBottom: '1.2em' }}>This app is not intended for users under the age of 13. We do not knowingly collect personal information from children.</p>

      <h2 style={{ fontWeight: 500, fontSize: '1.3em', marginTop: '30px' }}>8. Contact</h2>
      <p style={{ marginBottom: '1.2em' }}>If you have any questions or requests, please email us at <a href="mailto:contact@cruxlabs.app" style={{ color: '#0275d8' }}>contact@cruxlabs.app</a>.</p>

      <p style={{ marginBottom: '1.2em' }}><em>Last updated: August 2025</em></p>
    </div>
  );
};

export default PrivacyPolicy;
